import { FormProvider } from 'react-hook-form';
import { useNavigate } from 'react-router';

import {
  OrdersFilters,
  OrdersFiltersMobile,
  OrdersPeriodFilter,
  OrdersTable,
  useOrdersTable,
  COLUMN_OPTIONS,
  SORT_OPTIONS,
} from '~domains/orders/widgets/orders-table';

import PlusIcon from '~shared/assets/icons/plus.svg?react';
import { ROUTES } from '~shared/config/routes';
import { useIsDesktop } from '~shared/lib/responsive';
import { TableColumnsButton } from '~shared/ui/table-columns-button';
import { TableSortButton } from '~shared/ui/table-sort-button';

import { Button } from '@breezeventures/ui-kit/button';
import { Typography } from '@breezeventures/ui-kit/typography';

import { OrdersLayout } from './ui/layout';

export { CreateOrderPage } from './create';

export const OrdersPage = () => {
  const navigate = useNavigate();
  const isDesktop = useIsDesktop();
  const {
    methods,
    orders,
    total,
    isLoading,
    pagination,
    onPageChange,
    onPageSizeChange,
    applyFilters,
    resetFilters,
    clearSelectFilters,
    activeFiltersCount,
    showOnboarding,
    showAddButton,
    sorting,
    onSortingChange,
    visibleColumns,
    onVisibleColumnsChange,
    columnVisibility,
  } = useOrdersTable();

  const addOrderButton = showAddButton ? (
    <Button
      size={isDesktop ? 'm' : 's'}
      variant="primary"
      onClick={() => navigate(ROUTES.orders.create)}
    >
      <PlusIcon className="size-5" />
      Add order
    </Button>
  ) : null;

  const title = (
    <div
      className={`
        mb-4 flex w-full items-center justify-between gap-4
        lg:mb-6
      `}
    >
      <Typography.Title size="s" tag="h2">
        Orders
      </Typography.Title>
      <div className="flex items-center gap-2">
        {isDesktop && <OrdersPeriodFilter onChange={applyFilters} />}
        {addOrderButton}
      </div>
    </div>
  );

  return (
    <FormProvider {...methods}>
      <OrdersLayout title={title}>
        <div
          className={`
            flex flex-col gap-4
            lg:gap-6
          `}
        >
          {isDesktop ? (
            <OrdersFilters
              onFiltersChange={applyFilters}
              onReset={resetFilters}
            />
          ) : (
            <div className="flex gap-2">
              <OrdersPeriodFilter onChange={applyFilters} />
              <TableSortButton
                options={SORT_OPTIONS}
                value={sorting}
                onApply={onSortingChange}
              />
              <TableColumnsButton
                options={COLUMN_OPTIONS}
                value={visibleColumns}
                onApply={onVisibleColumnsChange}
              />
            </div>
          )}
          <OrdersTable
            orders={orders}
            total={total}
            isLoading={isLoading}
            showOnboarding={showOnboarding}
            pagination={pagination}
            onPageChange={onPageChange}
            onPageSizeChange={onPageSizeChange}
            sorting={sorting}
            onSortingChange={onSortingChange}
            columnVisibility={isDesktop ? undefined : columnVisibility}
          />
        </div>

        {!isDesktop && !showOnboarding && (
          <OrdersFiltersMobile
            activeCount={activeFiltersCount}
            onApply={applyFilters}
            onClear={clearSelectFilters}
          />
        )}
      </OrdersLayout>
    </FormProvider>
  );
};
